<template>
	<div>
		<div class="list">
			<div class="col bg1">
				<div class='no bb'>场次</div>
				<div class='vs bb'>对阵</div>
				<div class='bet bb'>胜平负</div>
				<div class='rs'>赛果</div>
			</div>
			<div class="col" :class="{'bg1':index % 2 == 1, 'bg2': index % 2 == 0}" v-for="(i,index) in matchList" :key="index">
				<div class='no bb'>{{index + 1}}</div>
				<div class='vs bb'>
					<div class="name">{{i.home}}</div>
					<div class="uvs"> vs </div>
					<div class="name">{{i.away}}</div>
				</div>
				<div class='bet bb'>
					<span v-if="i.bets.length == 0">*</span>
					<span v-for="(ii, tt) in i.bets" :class="{'red': i.rs == ii}">{{ii}}</span>
				</div>
				<div class='rs'>
					<span v-if="i.bets.length == 0">-</span>
					<span v-if="i.bets.length == 0">{{i.rs}}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props:['matchList'],
		name:"winloseTable",
		data() {
			return {
				
			};
		}
	}
</script>

<style scoped lang="scss">
	.list {
		display: flex; flex-direction: row; align-items: center;
		.col {
			width: 35px;
			font-size: 12px;
			color: #333333;
			.no {
				font-size: 12px;
				display: flex;
				justify-content: center;
				align-items: center;
				height: 35px;
				text-align: center;
			}
			.vs {
				font-size: 12px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				height: 175px;
				text-align: center;
				.name {
					height: 70px;
				}
				.uvs {
					height: 25px;
					font-weight: bold;
				}
			}
			.bet {
				font-size: 12px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				height: 60px;
				text-align: center;
				.red {
					color: red;
				}
			}
			.rs {
				font-size: 12px;
				display: flex;
				justify-content: center;
				align-items: center;
				height: 40px;
				text-align: center;
			}
			.bb {
				border-bottom: solid 1px #FFFFFF;
			}
		}
		.bg1 {
			background-color: #ECECEC;
		}
		.bg2 {
			background-color: #FCFCFC;
		}
	}
</style>